import script from "./BasePagination.vue?vue&type=script&setup=true&lang=js"
export * from "./BasePagination.vue?vue&type=script&setup=true&lang=js"

import "./BasePagination.vue?vue&type=style&index=0&id=2ca0c30f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ca0c30f"]])

export default __exports__